module.exports = __webpack_public_path__ + "img/China Construction Bank.5b281f37.png";